module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-16.4e01c59a.png";